import client from "./Client";
const url = "/api/v1";
const api = {
  getLoginStatus: () => client.get(`${url}/logged_in`),
  login: (user) => client.post(`${url}/login`, user),
  signup: (user) => client.post(`${url}/signup`, user),
  activate: (user) => client.post(`${url}/activate`, user),
  logout: () => client.delete(`${url}/logout`),
};
export default api;
